import { gql } from '@apollo/client';
import type { SerializedHardware } from '@enmon/commons/lib/tools';

export const GET_HARDWARES_QUERY = gql`
  query getHardwares {
    hardwares {
      data {
        id
        attributes {
          name
          category
        }
      }
    }
  }
`;

export type HardwareForSelect = Pick<SerializedHardware, 'name' | 'category'> & { id: string };

export interface GetHardwaresQueryResult {
  hardwares: {
    data: HardwareForSelect[];
  };
}
